/**
 * at-training-schedule.js — "Upcoming Training Classes" expand/collapse
 * Reference: Asana 1219660300610760
 *
 * The table renders every class, but only the first few are visible. The
 * "View Full Training Calendar" button reveals the rest in place (no new
 * page) and collapses them again.
 *
 * Beside the table (1200px up) the promo card keeps the height it had while
 * collapsed, so it does not stretch down the whole expanded table.
 *
 * In the theme editor, selecting a hidden class expands the table so the
 * merchant can see the row they are editing.
 */

if (!customElements.get('at-training-schedule')) {
  class TrainingSchedule extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-schedule-toggle]');
      this.label = this.querySelector('[data-schedule-toggle-label]');
      this.extraRows = [...this.querySelectorAll('[data-schedule-extra]')];
      this.promo = this.parentElement?.querySelector('.at-training-schedule__promo');
      if (!this.toggle || this.extraRows.length === 0) return;

      this.toggle.addEventListener('click', this.handleToggle);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.handleToggle);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleToggle = () => {
      const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
      this.setExpanded(!expanded);
      if (expanded) this.toggle.scrollIntoView({ block: 'nearest' });
    };

    handleBlockSelect = (event) => {
      if (this.extraRows.some((row) => row.contains(event.target))) this.setExpanded(true);
    };

    setExpanded(expanded) {
      if (this.promo && expanded) {
        this.promo.style.setProperty('--at-promo-collapsed-height', `${this.promo.offsetHeight}px`);
      }
      this.extraRows.forEach((row) => {
        row.hidden = !expanded;
      });
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.label.textContent = expanded ? this.toggle.dataset.labelExpanded : this.toggle.dataset.labelCollapsed;
    }
  }

  customElements.define('at-training-schedule', TrainingSchedule);
}
